/** Cartão de produto: enviar à cliente e acompanhar cliques e compras no site. */
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api, ErroApi } from "./api";

export interface ProdutoEnviado {
  id: string;
  nome: string;
  enviadoEm: string;
  vendedora: string | null;
  cliques: number;
  temLink: boolean;
  pedido: { numero: number | null; total: number | null } | null;
}

export const useProdutosEnviados = (conversaId: string) =>
  useQuery({
    queryKey: ["conversa", conversaId, "produtos-enviados"],
    queryFn: () => api.get<ProdutoEnviado[]>(`/conversas/${conversaId}/produtos-enviados`),
  });

export function useEnviarProduto(conversaId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (produtoId: string) =>
      api.post(`/conversas/${conversaId}/produtos/enviar`, {
        produtoId,
        idCliente: crypto.randomUUID(),
      }),
    onSuccess: () => {
      toast.success("Cartão do produto enviado!");
      void qc.invalidateQueries({ queryKey: ["conversa", conversaId] });
    },
    onError: (e) =>
      toast.error(e instanceof ErroApi ? e.message : "Não foi possível enviar o produto."),
  });
}
